module.exports = __webpack_public_path__ + "img/home_mobile.9412e341.svg";